
import React from 'react';

const ModeSelect = (props) => {
	const {
		onSelect,
		options,
		title
	} = props;

	return (
		<div className="modeSelect">
			<span>{title}</span>
			<div className="d-flex justify-content-between">
				{
					options && options.length &&
					options.map((item, i) => (
						<div className={`modeSelect-option ${item.checked ? 'active' : ''}`}
							key={i}
							onClick={() => {
								onSelect(item)
							}}>
							{item.label}
						</div>
					))
				}
			</div>
		</div>
	);
};

export default ModeSelect;
